export default "__VITE_PUBLIC_ASSET__e81079a3__"